<div class="banner-container-main" *ngIf="visible" @fadeInOutAnimation>
    <a [href]="getDemoLink()" target="_blank" class="banner-link-wrapper">
        <div class="floating-banner" [ngClass]="backgroundClass">
            <div class="banner-content">
                <div class="content" [ngClass]="{ 'banner2-gap': bannerId === 3 }">
                    <span class="banner-message"
                        [ngClass]="bannerId === 3 ? 'lato-26-n-vw' : 'lato-20-n-vw'"
                        [innerHTML]="formattedParagraphText">
                    </span>

                    <button class="lato-16-n-vw banner-button"
                        [ngClass]="{ 'gradient-banner-button-purple': bannerId === 2 || bannerId === 3 }">
                        {{ buttonText }}
                    </button>
                </div>
            </div>
        </div>
    </a>
</div>